import React, { memo, useCallback } from 'react';
import Div from '@/shared/Div';
import Map from '@/components/Map';
import ProductBanner from '@/shared/crisp/ProductBanner'; // Make sure to import ProductBannerProps
import withContentFlags from '@/hoc/withContentFlags';

interface BannerItem {
  id: string;
}

interface HomeProductBannersProps {
  list: BannerItem[];
  isActive: boolean;
}

const HomeProductBanners = (props: HomeProductBannersProps) => {
  const { list, isActive = false } = props;
  const render = useCallback((item: BannerItem) => {
    const { id, ...bannerProps } = item;
    const key = `product-banner-${id}`;
    return <ProductBanner key={key} dataTestId={key} {...bannerProps} />;
  }, []);

  return isActive ? (
    <Div className="flex flex-col sm:flex-row text-center">
      <Map list={list} render={render} />
    </Div>
  ) : null;
};

export default withContentFlags(memo(HomeProductBanners));
